import { Injectable } from '@angular/core';
import { CustomFormsApi } from 'src/app/api/observations/custom-forms/custom-forms.api';
import { PagedModel } from 'src/app/model/base/paged.model';
import { CreateObservationDTO } from 'src/app/model/observation/diff/diff-create-dto.model';

@Injectable({
    providedIn: 'root'
})
export class CustomFormsService {

    constructor(private customFormsAPI: CustomFormsApi) { }

    GetCustomFormForUserForm = (userFormId: string) =>
        this.customFormsAPI.GetCustomFormForUserForm(userFormId);

    getPublishedCustomFormsForPortal = (paging: PagedModel) =>
        this.customFormsAPI.getPublishedCustomFormsForPortal(paging);

    getPublishedCustomFormsForIndividual = (paging: PagedModel) => 
        this.customFormsAPI.getPublishedCustomFormsForIndividual(paging);

    getUserForm = (userFormId: string) =>
        this.customFormsAPI.getUserForm(userFormId);

    createUserForm = (observation: CreateObservationDTO) =>
        this.customFormsAPI.createUserForm(observation);

    saveUserForm = (userFormId: string, formAnswers: { [key: string]: string }) =>
        this.customFormsAPI.saveUserForm(userFormId, formAnswers);

    submitUserForm = (userFormId: string, formAnswers: { [key: string]: string }) =>
        this.customFormsAPI.submitUserForm(userFormId, formAnswers);

    signUserForm = (userFormId: string, questionId: string) =>
        this.customFormsAPI.signUserForm(userFormId, questionId);
    
    removeSignatureUserForm = (userFormId: string, questionId: string) =>
        this.customFormsAPI.removeSignatureUserForm(userFormId, questionId);
}
